import React, { useMemo } from 'react';

import { GridBodyType } from 'enums';

import { GridEntityConfig } from '../grid-types';
import { useLevelIndex } from './level-index-hook';

const WITHOUT_BODY = () => <></>;
export const useGridBody = (
  gridConfig?: GridEntityConfig[],
  gridBody?: GridBodyType
) => {
  const levelIndex = useLevelIndex(gridConfig);

  return useMemo(() => {
    if (levelIndex === undefined || !gridConfig || !gridBody) {
      return WITHOUT_BODY;
    }

    const BodyComponent =
      gridConfig[levelIndex]?.bodyComponents?.[gridBody] ?? WITHOUT_BODY;

    return BodyComponent;
  }, [gridBody, gridConfig, levelIndex]);
};
